import type { ReactNode } from 'react'
import { Sheet, SheetContent } from '../ui/sheet'

interface Props {
  open: boolean
  onClose: () => void
  children: ReactNode
}

// Hosts the AI panel as a bottom sheet on mobile (the inline right
// column does not fit). The default close-X is hidden — the AI panel
// has its own toggle and the backdrop/Esc still close it.
export default function MobileAiSheet({ open, onClose, children }: Props) {
  return (
    <Sheet open={open} onOpenChange={(o) => { if (!o) onClose() }}>
      <SheetContent side="bottom" close={false} className="h-[88vh] p-0 gap-0">
        {children}
      </SheetContent>
    </Sheet>
  )
}
